import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "46",
  height: "54",
  fill: "none",
  viewBox: "0 0 46 54"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M45.442 21.719 24.378.575a2 2 0 0 0-.3-.244c-.05-.029-.107-.058-.156-.087-.058-.03-.116-.069-.184-.098-.068-.03-.136-.039-.204-.058-.058-.02-.107-.04-.165-.049A1.7 1.7 0 0 0 22.99 0c-.126 0-.252.01-.378.039-.058.01-.107.03-.156.049-.067.02-.136.039-.203.068a2 2 0 0 0-.175.097c-.049.03-.107.05-.155.088a2.4 2.4 0 0 0-.301.244L.568 21.719a1.96 1.96 0 0 0 0 2.757c.378.38.873.575 1.368.575s.99-.195 1.37-.575L21.058 6.655v45.396A1.95 1.95 0 0 0 23 54a1.95 1.95 0 0 0 1.941-1.949V6.655l17.754 17.821c.378.38.874.575 1.368.575.496 0 .99-.195 1.37-.575a1.96 1.96 0 0 0 0-2.757z"
    }, null, -1)
  ]))]))
}
export default { render: render }